import './tabs.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import find from 'lodash/find';

const propTypes = {
	selected: PropTypes.string,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]),
	onTabChange: PropTypes.func
};

const defaultProps = {
	selected: 0
};

class Tabs extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: this.props.selected
		};
	}

	componentDidMount() {
		if (this.props.onTabChange) {
			this.props.onTabChange(this.props.selected);
		}
	}

	onSwitchTab(selected, e) {
		e.preventDefault();

		this.setState(
			prevState => ({ selected }),
			() => {
				if (this.props.onTabChange) {
					this.props.onTabChange(selected);
				}
			}
		);
	}

	render() {
		return (
			<div className="ui-tabs">
				<ul className="ui-tabs__labels">
					{React.Children.map(this.props.children, (child, index) => child && (
						<li key={index}>
							{child.props.isVisible && (
								<a
									href="#"
									className={cn({ active: child.props.index === this.state.selected })}
									onClick={this.onSwitchTab.bind(this, child.props.index)}
								>
									{child.props.label}
									{child.props.count && <span className="ui-tabs__labels-count">{child.props.count}</span>}
								</a>
							)}
						</li>
					))}
				</ul>
				<div className="ui-tabs__content">
					{  find(React.Children.toArray(this.props.children), child => child.props.index === this.state.selected) }
				</div>
			</div>
		);
	}
}

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;

export default Tabs;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/tabs/tabs.js